document.addEventListener( 'click', function ( e ) {
	const btn = e.target.closest( '[data-copy-link]' );
	if ( ! btn ) return;

	e.preventDefault();
	navigator.clipboard.writeText( btn.dataset.copyLink );
} );
